export enum OpportunityTypeAPIResponse {
  Solar = 'solar',
  Storage = 'storage',
  SolarAndOrStorage = 'solarAndOrStorage',
  None = 'none',
}
